import { AuthService } from '../auth.service';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HandlerService } from '../handler.service';
import { Platform } from '@angular/cdk/platform';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ExcelService } from '../excel.service';
import { FormControl } from '@angular/forms';
import { Component, ViewChild } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { concat } from 'rxjs';
let k = 1;
let p = 1;

@Component({
  selector: 'app-new-manage-order',
  templateUrl: './new-manage-order.component.html',
  styleUrls: ['./new-manage-order.component.scss'],
})
export class NewManageOrderComponent {
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ['id', 'custName', 'place', 'region', 'service', 'payment', 'vendorpayment', 'status'];
  dataSource: any;
  orderItems: any = [];
  cancelledReasons;
  cancelId;
  cancellation;
  url;
  customerPop: boolean = false;
  userData: any;
  userCheck: boolean;
  cloneUsers: any = [];
  custmob;
  notes;
  id;
  numb;
  confirm: boolean = false;
  check: boolean = false;
  send: boolean = false;
  rescheduleOrd: boolean = false;
  minDate = new Date();
  fdateCheck;
  availableSlots = [];
  vendor;
  orderId;
  startdate = new Date();
  enddate;
  date = new Date();
  dateFormat;
  excelDataAll: any = [];
  excell: any = [];
  search: any = [];
  category;
  openPop: boolean = false;
  popLoad: boolean;
  itemOrders: any = [];
  Cview: boolean = true;
  loader: boolean = false;
  allocationOptions: any;
  optionName;
  optionId;
  filterPop: boolean = false;
  searchShow: boolean = true;
  contDrop: boolean = false;
  orgs;
  orgName;
  orgId;
  paymentName;
  paymentId;
  vendorPaymentName;
  count;
  vendorPaymentId;
  custname;
  eDate;
  orderid;
  advanceSearch: boolean = false;
  active: boolean = false;
  userChecke: boolean;
  vendorPayment = [{ id: 2, name: "Paid" }, { id: 1, name: "Not Paid" }]
  payment = [{ id: 2, name: "Paid" }, { id: 1, name: "Not Paid" }, { id: 3, name: "Pending" }]
  statusObj = [{ id: 7, name: "Pending Allocation" },
  { id: 9, name: "Assigned" },
  { id: 10, name: "Scheduled" },
  { id: 3, name: "Completed" },
  { id: 11, name: "Partially Fixed" },
  { id: 12, name: "Allocated" },
  { id: 5, name: "Cancelled" }
  ]
  statusName;
  statusId;
  cateName;
  cateId;
  contractors;
  cate1Id;
  active1: boolean = false;
  contractorId;
  ContractorName;
  filter: boolean;
  serviceFlat;
  custName;
  categoryName;
  reqStatusName;
  payStatusName;
  vendorpayStatusName;
  time = "Time";
  availSlot: boolean;
  slotClicked: boolean;
  openSlot: boolean = false;
  changeDate: boolean = false;
  idFilter = new FormControl('');
  paymentStatusFilter = new FormControl('');
  categoryNameFilter = new FormControl('');
  serviceRegionFilter = new FormControl('');
  serviceFlatFilter = new FormControl('');
  custNameFilter = new FormControl('');
  statusFilter = new FormControl('');
  vendorpaymentStatusFilter = new FormControl('');
  filterValues = {
    id: '',
    serviceFlat: '',
    categoryName: '',
    delRegion: '',
    custName: '',
    payStatusName: '',
    vendorpayStatusName: '',
    reqStatusName: ''

  };
  mbv: boolean;
  notifyItems: any = [];
  openPopUp: boolean = false;
  message: any;
  filterLength;
  fDate;
  slots;
  slot;
  Oid;
  endTime;
  slotDate;
  config;
  criditValue;
  data
  statussearch: any = [];
  phone;
  customerDetails: any;
  currentDate;
  newCustPop: boolean;
  toggleView: boolean;
  fName;
  constructor(public auth: AuthService, private router: Router, public handler: HandlerService,
    public service: ApiService, private bottomSheet: MatBottomSheet, public platform: Platform, private excelService: ExcelService) { }

  ionViewWillEnter() {
    this.active = false;
    this.loader = true;
    this.changeDate = false;
    sessionStorage.clear();
    this.getConfig();
    this.blockDate();
    this.startDate();
    this.enddate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    this.endDate();
    this.url = window.location.href;
    if (this.url.includes('vendor-manage-order')) {
      this.toggleView = true;
    } else {
      this.toggleView = false;
    }
    this.Oid = localStorage.getItem('organizationId')
    sessionStorage.setItem('vendorApp', 'true');
    this.idFilter.valueChanges
      .subscribe(
        id => {
          this.filterValues.id = id;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.paymentStatusFilter.valueChanges
      .subscribe(
        vendorpayStatusName => {
          this.filterValues.vendorpayStatusName = vendorpayStatusName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.vendorpaymentStatusFilter.valueChanges
      .subscribe(
        payStatusName => {
          this.filterValues.payStatusName = payStatusName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.statusFilter.valueChanges
      .subscribe(
        reqStatusName => {
          this.filterValues.reqStatusName = reqStatusName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.categoryNameFilter.valueChanges
      .subscribe(
        categoryName => {
          this.filterValues.categoryName = categoryName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.serviceRegionFilter.valueChanges
      .subscribe(
        delRegion => {
          this.filterValues.delRegion = delRegion;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.serviceFlatFilter.valueChanges
      .subscribe(
        serviceFlat => {
          this.filterValues.serviceFlat = serviceFlat;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.custNameFilter.valueChanges
      .subscribe(
        custName => {
          this.filterValues.custName = custName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.dateFormat = this.auth.getDateformat();
    if (this.platform.ANDROID || this.platform.IOS) {
      this.mbv = false;
    }
    else {
      this.mbv = true;
    }
    this.getCategory();
    this.getOrgs();
    this.getCancelReason();

  }

  getCategory() {
    this.service.getOrgCategory().subscribe((res: any) => {
      this.category = res;
      // if(this.filter==true){
      // console.log(this.filter)
      this.searchfilter();
      // }else{ 
      // this.getAllOrder(this.date);
      // }
    })
  }

  getOrgs() {
    this.service.getOrg().subscribe((res: any) => {
      this.orgs = res;
    })
  }


  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem('len')

  }
  getsc() {
    this.loader = true;
    this.filterPop = false;
    this.service.getUsersByOrg('SC', this.orgId, null).subscribe((res: any) => {
      if (res) {
        this.contractors = res;
        if (this.contractors && this.contractors.length > 0) {
          this.contractors.sort(function (a, b) {
            var nameA = a.firstName, nameB = b.firstName;
            if (nameA < nameB) { return -1; }
            if (nameA > nameB) { return 1; }
            return 0;
          })
        }
        this.contractors.map(res => {
          if (res.categoryLists)
            res.categoryLists.map(res1 => {
              if (res1.categoryId == this.cateId) {
                this.cate1Id = res1.categoryId
                Object.assign(res, { vId: this.cate1Id })
              }
            })
        })
        this.contractors = this.contractors.filter(res => { return res.reqRoleApproved == true && res.vId == this.cateId });
        // this.contractors= res.filter(res =>{return res.reqRoleApproved == true});
        this.loader = false;
        this.filterPop = true;
      } else {
        this.loader = false;
        this.contractors = [];
        this.filterPop = true;

      }
    }, err => {
      this.handler.err(err)
    })
  }


  getAllOrder(date) {
    this.currentDate = this.returnDate(date);
    this.orderItems = [];
    this.loader = true;
    k = 1;
    this.service.getAllOrderByDate(this.returnDate(date), k).subscribe((res: any) => {
      if (res) {
        this.orderItems = res;
        this.orderItems = this.orderItems.filter(res => { return res.status == 7 || res.status == 3 || res.status == 10 || res.status == 5 || res.status == 9 || res.status == 12 || res.status == 11 })
        this.orderItems.map(res => {
          Object.assign(res, { clicked: false })
        })
        this.orderItems.map(res => {
          Object.assign(res, { contactNbrMob: res.customer.contactNbrMob })
        })
        this.orderItems.map(dat => {
          this.category.map(dat1 => {
            if (dat.categoryId == dat1.id)
              Object.assign(dat, { categoryName: dat1.name })
          })
          if (dat.paymtStatus == 1)
            Object.assign(dat, { payStatusName: "Not Paid" })
          if (dat.paymtStatus == 2)
            Object.assign(dat, { payStatusName: "Paid" })
          if (dat.paymtStatus == 3)
            Object.assign(dat, { payStatusName: "Pending" })
          if (dat.vendorPaymentStatus == 1)
            Object.assign(dat, { vendorpayStatusName: "Not Paid" })
          if (dat.vendorPaymentStatus == 2)
            Object.assign(dat, { vendorpayStatusName: "Paid" })
          if (dat.status == 7)
            Object.assign(dat, { reqStatusName: "Pending Allocation" })
          if (dat.status == 2)
            Object.assign(dat, { reqStatusName: "Completed" })
          if (dat.status == 5)
            Object.assign(dat, { reqStatusName: "Cancelled" })
          if (dat.status == 10)
            Object.assign(dat, { reqStatusName: "Scheduled" })
          if (dat.status == 9)
            Object.assign(dat, { reqStatusName: "Assigned" })
          if (dat.status == 11)
            Object.assign(dat, { reqStatusName: "Partially Fixed" })
          if (dat.appt == true)
            Object.assign(dat, { serviceFlat: dat.flatName })
          if (dat.appt == false)
            Object.assign(dat, { serviceFlat: dat.street })
          if (dat.appt == "" || dat.appt == undefined)
            Object.assign(dat, { serviceFlat: "Not Specified" })
        })
        this.dataSource = new MatTableDataSource(this.orderItems);
        this.dataSource.filterPredicate = this.createFilter();
        this.dataSource.sort = this.sort;
        this.loader = false;
        k++;
      } else {
        this.orderItems = [];
        this.loader = false;
        this.handler.res('No Data For You ')


      }
    }, err => {
      this.orderItems = [];
      this.loader = false;
    })
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.id.toString().toLowerCase().indexOf(searchTerms.id) !== -1
        && data.custName.toString().toLowerCase().indexOf(searchTerms.custName) !== -1
        && data.serviceName.toString().toLowerCase().indexOf(searchTerms.categoryName) !== -1
        && data.serviceRegion.toString().toLowerCase().indexOf(searchTerms.delRegion) !== -1
        // && data.serviceFlat.toString().toLowerCase().indexOf(searchTerms.serviceFlat) !== -1
        && data.payStatusName.toString().toLowerCase().indexOf(searchTerms.payStatusName) !== -1
        && data.vendorpayStatusName.toString().toLowerCase().indexOf(searchTerms.vendorpayStatusName) !== -1
        && data.reqStatusName.toString().toLowerCase().indexOf(searchTerms.reqStatusName) !== -1
    }
    return filterFunction;
  }

  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let year = data.getFullYear();
    return year + '-' + month + '-' + date;
  }


  next() {
    let x = new Date(JSON.parse(JSON.stringify(this.date)));
    let newDate = new Date(x.setDate(x.getDate() + 1));
    this.date = newDate;
    k = 1;
    this.orderItems = [];
    this.currentDate = this.returnDate(this.date);
    this.getAllOrder(this.date)
  }

  prev() {
    let x = new Date(JSON.parse(JSON.stringify(this.date)));
    let newDate = new Date(x.setDate(x.getDate() - 1));
    this.date = newDate
    k = 1;
    this.currentDate = this.returnDate(this.date);
    this.orderItems = [];
    this.getAllOrder(this.date)
  }

  popUpOpen(id) {
    this.openPop = true;
    this.popLoad = true;
    this.service.getOrderById(id).subscribe((res: any) => {
      this.itemOrders = res.itemOrders;
      this.popLoad = false;
      this.notes = res.notes;
    })
  }

  cancel(id) {
    this.cancelId = id;
    this.confirm = true;
  }

  getCancelReason() {
    this.service.getcancellationReason().subscribe(res => {
      this.cancelledReasons = res;
    })
  }


  clearArray2(value) {
    this.cancellation = value.name;
  }

  orderCancellation() {
    this.loader = true;
    var post = {
      "cancellationReasons": this.cancellation
    }
    this.service.cancelOrder(this.cancelId, post).subscribe((res: any) => {
      this.handler.res("Order Cancelled successfully");
      this.confirm = false;
      k = 1;
      p = 1;
      // this.getAllOrder(this.date)
      this.searchfilter();
    })
  }

  Allocations(data, id) {
    if (data.status == 7 && (this.auth.checkCapability('FSA') || this.auth.checkCapability('SPVR') || this.auth.checkCapability('VM') || this.auth.checkCapability('CUSTRQH') || this.auth.checkCapability('CUSTSUP'))) {
      this.allocationOptions = [{ id: 1, name: "Assign Employee" }, { id: 4, name: "Reschedule" }]
    }
    if (data.status == 9 && (this.auth.checkCapability('FSA') || this.auth.checkCapability('SPVR') || this.auth.checkCapability('VM') || this.auth.checkCapability('CUSTRQH') || this.auth.checkCapability('CUSTSUP'))) {
      this.allocationOptions = [{ id: 1, name: "Assign Employee" }, { id: 4, name: "Reschedule" }]
    }
    if ((data.status == 12 || data.status == 10) && (this.auth.checkCapability('FSA') || this.auth.checkCapability('SPVR') || this.auth.checkCapability('VM') || this.auth.checkCapability('CUSTRQH') || this.auth.checkCapability('CUSTSUP'))) {
      this.allocationOptions = [{ id: 3, name: "Change Allocation" }, { id: 4, name: "Reschedule" }, { id: 5, name: "Accept Order" }, { id: 8, name: 'Accept' }]
    }
    if ((data.status == 12 || data.status == 10) && !this.auth.checkCapability('FSA') && this.auth.checkCapability('SP')) {
      this.allocationOptions = [{ id: 3, name: "Change Allocation" }, { id: 5, name: "Accept Order" }]
    }
    if (data.status == 9 && !this.auth.checkCapability('FSA') && this.auth.checkCapability('SP')) {
      this.allocationOptions = [{ id: 1, name: "Assign Employee" }]
    }

    if ((data.status == 12 || data.status == 10) && ((this.auth.checkCapability('FSA') || this.auth.checkCapability('SPVR') || this.auth.checkCapability('VM') || this.auth.checkCapability('CUSTRQH') || this.auth.checkCapability('CUSTSUP')) && this.auth.checkCapability('SP'))) {
      this.allocationOptions = [{ id: 3, name: "Change Allocation" }, { id: 4, name: "Reschedule" }, { id: 5, name: "Accept Order" }]
    }
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.allocationOptions,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.optionName = res.name;
        this.optionId = res.id;
        if (this.optionId == 0) {
          this.assignVendor1(data, id);
        }
        if (this.optionId == 2) {
          this.changeVendorselect1(data, id);
        }
        if (this.optionId == 1) {
          this.assignVendor1(data, id);
        }
        if (this.optionId == 3) {
          this.assignVendor(data, id);
        }
        if (this.optionId == 4) {
          this.rescheduleOrd = true;
          this.orderId = id;
        }
        if (this.optionId == 5) {
          this.acceptOrder(data)
        }
      }
    });
  }
  Vendorselect1(data, id) {
    sessionStorage.setItem('orderId', data.id);
    sessionStorage.setItem('catId', data.categoryId);
    if (this.url.includes('vendor-manage-order')) {
      this.router.navigate(['/homeVendorAssign/', +id]);
    } else {
      this.router.navigate(['/vendorAssign/', +id]);
    }

  }
  vendorPay(data) {
    if (this.auth.checkCapability('FSA') || this.auth.checkCapability('VM')) {
      if (this.url.includes('vendor-manage-order')) {
        this.router.navigate(['/home-Vendor-invoice/', +data.id]);
      } else {
        this.router.navigate(['/vendor-invoice/', +data.id]);
      }
    } else {
      this.handler.staticError('User does not have this access!!!')
    }

  }
  changeVendorselect1(data, id) {
    sessionStorage.setItem('orderId', data.id);
    sessionStorage.setItem('catId', data.categoryId);
    sessionStorage.setItem('vendor', data.orgId);
    if (this.url.includes('vendor-manage-order')) {
      this.router.navigate(['/homeChangeVendorAssign/', +id]);
    } else {
      this.router.navigate(['/changeVendorAssign/', +id]);
    }
  }

  assignVendor1(data, id) {
    sessionStorage.setItem('orderId', data.id);
    sessionStorage.setItem('catId', data.categoryId);
    sessionStorage.setItem('vendor', data.orgId)
    if (this.url.includes('vendor-manage-order')) {
      this.router.navigate(['/homeContractorAssign/', +id]);
    } else {
      this.router.navigate(['/contractorAssign/', +id]);
    }
  }


  assignVendor(data, id) {
    sessionStorage.setItem('orderId', data.id);
    sessionStorage.setItem('catId', data.categoryId);
    sessionStorage.setItem('employee', data.serviceContractorId);
    sessionStorage.setItem('vendor', data.orgId)
    if (this.url.includes('vendor-manage-order')) {
      this.router.navigate(['/homeContractorAssign/', +id]);
    } else {
      this.router.navigate(['/contractorAssign/', +id]);
    }
  }


  viewChange(id) {
    if (id == 1) {
      this.Cview = true;
      this.searchShow = true;
      //  this.getAllOrder(this.date);
      this.searchfilter();
    }
    else {
      this.Cview = false;
      this.searchShow = false;
      // this.matTableData(this.date);
    }
  }

  filterReq() {
    this.filterPop = true;
  }

  openBottomSheet() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;
      }
    });
  }

  openBottomSheetVendorstatus() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.vendorPayment,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.vendorPaymentName = res.name;
        this.vendorPaymentId = res.id;
      }
    })
  }

  openBottomSheetstatus() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.payment,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.paymentName = res.name;
        this.paymentId = res.id;
      }
    })
  }

  openBottomSheetCheck() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.statusObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.statusName = res.name;
        this.statusId = res.id;
        this.statusFilters(this.statusId)
      }
    })
  }
  statusFilters(id) {
    let patienttype: any = [];
    patienttype = this.statusObj.filter(res => { return res.id == id })
    this.statussearch.push(patienttype[0])
    this.statussearch = this.statussearch.filter((x, i, a) => a.indexOf(x) == i);
  }
  openBottomSheetOrg(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.orgs,
    });
    dialogRef.afterDismissed().subscribe((res: any) => {
      if (res) {
        this.loader = true;
        this.orgName = res.name;
        this.orgId = res.id;
        this.contDrop = true;
        this.getsc();
      }

    });
  }

  openBottomSheetCon(): void {
    localStorage.setItem('showBar', 'true')
    if (!this.active1 && this.orgName) {
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.contractors,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        this.statusName = ""
        this.contractorId = res.userId;
        if (res.lastName)
          this.ContractorName = res.firstName;
        else
          this.ContractorName = res.firstName;
      });
    } else {
      this.handler.staticError('Please select organisation')
    }
  }

  openBottomSheetCon1(): void {
    localStorage.setItem('showBar', 'true')
    if (!this.active1 && this.orgName) {
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.contractors,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        this.statusName = ""
        this.contractorId = res.userId;
        if (res.lastName)
          this.ContractorName = res.firstName;
        else
          this.ContractorName = res.firstName;
      });
    } else {
      this.handler.staticError('Please select organisation')
    }
  }

  changeApp() {
    sessionStorage.setItem('vendorApp', 'false')
    if (this.active) {
      if (this.auth.loged()) {
        this.router.navigate(['/bookservice1'])
      } else {
        this.router.navigate(['/bookservice'])
      }

    } else {
      if (this.auth.loged()) {
        this.router.navigate(['/vendor-register1'])
      } else {
        this.router.navigate(['/vendor-register'])
      }

    }
  }


  cancelFilter() {
    this.loader = true;
    this.startdate = new Date();
    this.enddate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    this.startDate();
    this.endDate();
    this.statusName = "";
    this.advanceSearch = false;
    this.statusName = "";
    this.custname = "";
    this.phone = "";
    this.statussearch = [];
    this.orderid = "";
    this.statusId = undefined;
    this.contractorId = undefined;
    this.ContractorName = "";
    this.paymentName = "";
    this.paymentId = undefined;
    this.cateName = "";
    this.cateId = undefined;
    this.orgName = "";
    this.orgId = undefined;
    this.filterPop = false;
    this.contDrop = false;
    this.filter = false;
    this.vendorPaymentName = "";
    this.vendorPaymentId = "";
    // this.getAllOrder(this.date)
    // this.matTableData(this.date)
    this.searchfilter();
  }

  searchfilter() {
    p = 1;
    var statusId = [];
    this.filter = true;
    this.loader = true;
    this.statussearch.map(res => {
      statusId.push(res.id)
    })
    let post = {
      "id": this.orderid,
      "fromDate": this.fDate,
      "toDate": this.eDate,
      "serviceContractorId": this.contractorId,
      "vendorId": this.orgId,
      "paymtStatus": this.paymentId,
      "vendorPaymentStatus": this.vendorPaymentId,
      "orderType": 1,
      "categoryId": this.cateId,
      "custName": this.custname
    }
    if (this.statussearch) {
      Object.assign(post, { statuses: statusId })
    }
    if (this.phone) {
      Object.assign(post, { custContactNbrMob: '+91' + this.phone })
    }
    this.getSummary(post);
    this.service.getOrdersSearch(p, post).subscribe((res: any) => {
      if (res) {
        this.orderItems = res;
        this.orderItems = this.orderItems.filter(res => { return res.status == 7 || res.status == 3 || res.status == 10 || res.status == 5 || res.status == 12 || res.status == 11 || res.status == 9 })
        this.orderItems.map(res => {
          Object.assign(res, { contactNbrMob: res.customer.contactNbrMob })
        })
        this.orderItems.map(res => {
          Object.assign(res, { clicked: false })
        })
        this.orderItems.map(dat => {
          this.category.map(dat1 => {
            if (dat.categoryId == dat1.id)
              Object.assign(dat, { categoryName: dat1.name })
          })
          if (dat.paymtStatus == 1)
            Object.assign(dat, { payStatusName: "Not Paid" })
          if (dat.paymtStatus == 2)
            Object.assign(dat, { payStatusName: "Paid" })
          if (dat.paymtStatus == 3)
            Object.assign(dat, { payStatusName: "Pending" })
          if (dat.vendorPaymentStatus == 1)
            Object.assign(dat, { vendorpayStatusName: "Not Paid" })
          if (dat.vendorPaymentStatus == 2)
            Object.assign(dat, { vendorpayStatusName: "Paid" })
          if (dat.status == 7)
            Object.assign(dat, { reqStatusName: "Pending Allocation" })
          if (dat.status == 2)
            Object.assign(dat, { reqStatusName: "Completed" })
          if (dat.status == 5)
            Object.assign(dat, { reqStatusName: "Cancelled" })
          if (dat.status == 10)
            Object.assign(dat, { reqStatusName: "Scheduled" })
          if (dat.status == 9)
            Object.assign(dat, { reqStatusName: "Assigned" })
          if (dat.status == 11)
            Object.assign(dat, { reqStatusName: "Partially Fixed" })
          if (dat.appt == true)
            Object.assign(dat, { serviceFlat: dat.flatName })
          if (dat.appt == false)
            Object.assign(dat, { serviceFlat: dat.street })
          if (dat.appt == "" || dat.appt == undefined)
            Object.assign(dat, { serviceFlat: "Not Specified" })
        })
        this.dataSource = new MatTableDataSource(this.orderItems);
        this.dataSource.filterPredicate = this.createFilter();
        this.dataSource.sort = this.sort;
        p++;
        this.loader = false;
      } else {
        this.loader = false;
        this.orderItems = [];
        this.handler.res("No Data Found");
      }
    }, err => {
      this.loader = false;
      // this.filterPop = true;
      this.handler.err(err);
    })
  }

  getSummary(data) {
    this.service.getOrdersSummary(data).subscribe((res: any) => {
      this.count = res;

    })
  }

  exportAsXLSX() {
    this.orderItems.map(res => {
      if (res.paymtStatus == 1)
        Object.assign(res, { payStatusName: "Not Paid" })
      if (res.paymtStatus == 2)
        Object.assign(res, { payStatusName: "Paid" })
      if (res.paymtStatus == 3)
        Object.assign(res, { payStatusName: "Pending" })
      if (res.vendorPaymentStatus == 1)
        Object.assign(res, { vendorpayStatusName: "Not Paid" })
      if (res.vendorPaymentStatus == 2)
        Object.assign(res, { vendorpayStatusName: "Paid" })

      this.excelDataAll.push({
        OrderId: res.id, CustomerName: res.custName, FlatName: res.flatName, Street: res.street, Region: res.delRegion,
        Categories: res.categoryName, Payment: res.payStatusName, VendorPayment: res.vendorpayStatusName
      })
    })
    this.excelService.exportAsExcelFile(this.excelDataAll, 'Order Details');

    this.excelDataAll = []
  }

  notify() {
    // this.send = true;
    // this.check = true;
    this.orderItems.map(res =>
      res.clicked = false)

    if (!this.send) {
      this.send = true;
    } else {
      this.send = false;
    }

    if (!this.check) {
      this.check = true;
    } else {
      this.check = false;
    }
  }

  triggerChange(data) {
    if (this.send) {
      data.clicked = !data.clicked
      this.notifyItems = this.orderItems.filter(res => res.clicked)
    }

  }

  sendNot() {
    this.notifyItems.map(res => {
      this.loader = true;
      var post = {
        "notifications": this.message
      }
      this.service.sendNotification(res.id, post).subscribe((res1: any) => {
        res.clicked = false;
        this.send = false;
        this.openPopUp = false;
        this.loader = false;
        this.check = false;
      }, err => {
        res.clicked = false;
        this.handler.err(err)
        this.send = false;
        this.openPopUp = false;
        this.loader = false;
        this.check = false;
      })
    })
  }

  mess() {
    this.service.getPaymentRemainderMsg().subscribe((res: any) => {
      this.message = res.notifications;
    })
    this.openPopUp = true;
  }

  clear() {
    this.search = "";
  }


  ordersByPage($event, date) {
    if (!this.filter && this.search.length == 0) {
      this.clear();
      this.service.getAllOrderByDate(this.returnDate(date), k).subscribe((res: any) => {
        if (res) {
          res.map(dat => {
            this.orderItems.push(dat);
          })
          this.orderItems = this.orderItems.filter(res => { return res.status == 7 || res.status == 3 || res.status == 10 || res.status == 5 || res.status == 9 || res.status == 12 || res.status == 11 })
          this.orderItems.map(res => {
            Object.assign(res, { clicked: false })
          })
          this.orderItems.map(dat => {
            this.category.map(dat1 => {
              if (dat.categoryId == dat1.id)
                Object.assign(dat, { categoryName: dat1.name })
            })
            if (dat.paymtStatus == 1)
              Object.assign(dat, { payStatusName: "Not Paid" })
            if (dat.paymtStatus == 2)
              Object.assign(dat, { payStatusName: "Paid" })
            if (dat.paymtStatus == 3)
              Object.assign(dat, { payStatusName: "Pending" })
            if (dat.status == 7)
              Object.assign(dat, { reqStatusName: "Pending Allocation" })
            if (dat.status == 2)
              Object.assign(dat, { reqStatusName: "Completed" })
            if (dat.status == 5)
              Object.assign(dat, { reqStatusName: "Cancelled" })
            if (dat.status == 10)
              Object.assign(dat, { reqStatusName: "Scheduled" })
            if (dat.status == 9)
              Object.assign(dat, { reqStatusName: "Assigned" })
            if (dat.status == 11)
              Object.assign(dat, { reqStatusName: "Partially Fixed" })
            if (dat.appt == true)
              Object.assign(dat, { serviceFlat: dat.flatName })
            if (dat.appt == false)
              Object.assign(dat, { serviceFlat: dat.street })
            if (dat.appt == "" || dat.appt == undefined)
              Object.assign(dat, { serviceFlat: "Not Specified" })
          })
          this.dataSource = new MatTableDataSource(this.orderItems);
          this.dataSource.filterPredicate = this.createFilter();
          this.dataSource.sort = this.sort;
          this.loader = false;
          k++;
        } else {
          this.loader = false;
        }
      }, err => {
        this.loader = false;
      })
    }
    if (this.filter && this.search.length == 0) {
      this.clear();
      var statusId = [];
      this.statussearch.map(res => {
        statusId.push(res.id)
      })
      let post = {
        "id": this.orderid,
        "fromDate": this.fDate,
        "toDate": this.eDate,
        "serviceContractorId": this.contractorId,
        "vendorId": this.orgId,
        "paymtStatus": this.paymentId,
        "vendorPaymentStatus": this.vendorPaymentId,
        "orderType": 1,
        "categoryId": this.cateId,
        "custName": this.custname
      }
      if (this.statusName) {
        Object.assign(post, { statuses: statusId })
      }
      if (this.phone) {
        Object.assign(post, { custContactNbrMob: '+91' + this.phone })
      }
      console.log(p)
      this.service.getOrdersSearch(p, post).subscribe((res: any) => {
        if (res) {
          res.map(dat => {
            this.orderItems.push(dat);
          })
          this.orderItems = this.orderItems.filter(res => { return res.status == 7 || res.status == 3 || res.status == 10 || res.status == 5 || res.status == 12 || res.status == 11 || res.status == 9 })
          this.orderItems.map(res => {
            Object.assign(res, { contactNbrMob: res.customer.contactNbrMob })
          })
          this.orderItems.map(res => {
            Object.assign(res, { clicked: false })
          })
          this.orderItems.map(dat => {
            this.category.map(dat1 => {
              if (dat.categoryId == dat1.id)
                Object.assign(dat, { categoryName: dat1.name })
            })
            if (dat.paymtStatus == 1)
              Object.assign(dat, { payStatusName: "Not Paid" })
            if (dat.paymtStatus == 2)
              Object.assign(dat, { payStatusName: "Paid" })
            if (dat.vendorPaymentStatus == 1)
              Object.assign(dat, { vendorpayStatusName: "Not Paid" })
            if (dat.vendorPaymentStatus == 2)
              Object.assign(dat, { vendorpayStatusName: "Paid" })
            if (dat.status == 7)
              Object.assign(dat, { reqStatusName: "Pending Allocation" })
            if (dat.status == 2)
              Object.assign(dat, { reqStatusName: "Completed" })
            if (dat.status == 5)
              Object.assign(dat, { reqStatusName: "Cancelled" })
            if (dat.status == 10)
              Object.assign(dat, { reqStatusName: "Scheduled" })
            if (dat.status == 9)
              Object.assign(dat, { reqStatusName: "Assigned" })
            if (dat.status == 11)
              Object.assign(dat, { reqStatusName: "Partially Fixed" })
            if (dat.appt == true)
              Object.assign(dat, { serviceFlat: dat.flatName })
            if (dat.appt == false)
              Object.assign(dat, { serviceFlat: dat.street })
            if (dat.appt == "" || dat.appt == undefined)
              Object.assign(dat, { serviceFlat: "Not Specified" })
          })
          this.dataSource = new MatTableDataSource(this.orderItems);
          this.dataSource.filterPredicate = this.createFilter();
          this.dataSource.sort = this.sort;
          p++;
          this.loader = false;
        } else {
          this.loader = false;
        }
      }, err => {
        this.loader = false;
      })
    }

  }
  pay(id) {
    if (this.url.includes('vendor-manage-order')) {
      this.router.navigate(['/home-record-pay/', +id]);
    } else {
      this.router.navigate(['/record-pay/', +id]);
    }
  }

  refreshData(event) {
    this.ionViewWillEnter();
  }

  returnDate1(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let year = data.getFullYear();
    return date + '-' + month + '-' + year;
  }

  startDate() {
    this.fDate = this.returnDate(this.startdate);
    this.slotDate = this.returnDate1(this.startdate);
  }
  endDate() {
    this.eDate = this.returnDate(this.enddate);
  }

  checkPreview() {
    this.openSlot = true;
    this.slotClicked = false;
    var post = {
      "targetCenterId": this.Oid,
      "targetSource": this.Oid,
      "schElements": [
        1
      ],
      "requestDate": this.fDate,
      "status": [
        "SlotsAvailable"
      ],
      "independentEntities": true,
      "slotDuration": 15
    }
    this.service.getTimeSlots(this.slotDate, post).subscribe((res: any) => {
      if (res) {
        this.availableSlots = res;
        this.availSlot = true;
        this.slotClicked = true;
      } else {
        this.handler.res("No Available Slots");
        this.availSlot = false;
        this.slotClicked = true;
      }

    })
  }

  setTime(data) {
    this.time = data.startTime;
    this.endTime = data.endTime;
    this.slot = data;
    this.slotClicked = false;
    this.openSlot = false;
    this.changeDate = true;
  }

  reschedule() {
    var post = {
      "apptDate": this.fDate,
      "apptTime": this.time,
      "apptEndTime": this.slot.endTime,
      "requestDates": [
        {
          "apptDate": this.fDate,
          "apptTime": this.time,
          "apptEndTime": this.slot.endTime,
          "status": 1
        }],
    }
    this.service.rescheduleOrder(this.orderId, post).subscribe((res: any) => {
      this.handler.res('Order Rescheduled Successfully!!')
      this.rescheduleOrd = false;
      // this.getAllOrder(this.date);
      this.searchfilter();
    })

  }
  blockDate() {
    // Block From Date
    var someDate = new Date();
    var numberOfFromDaysToAdd = 1;
    someDate.setDate(someDate.getDate() + numberOfFromDaysToAdd);
    var dd = someDate.getDate();
    var mm = someDate.getMonth() + 1;
    var month = mm - 1;
    var y = someDate.getFullYear();
    this.fdateCheck = new Date(y, month, dd)
  }


  close() {
    this.customerPop = false;
    this.numb = "";
    this.custName = "";
  }

  getUser(val) {
    let x = val.length;
    if (x > 2) {
      this.cloneUsers = [];
      this.service.searchCustomers("CUST", val, this.Oid).subscribe((res: any) => {
        if (res != null && res != "NO_CONTENT" && res.length > 0) {
          this.userChecke = true;
          // res.push({
          //   userId:1,
          //   firstName:'Create New Customer'
          // })  
          this.cloneUsers = JSON.parse(JSON.stringify(res));
          if (!this.custName) {
            this.cloneUsers = [];
          }
        } else {
          this.cloneUsers = [];
          this.cloneUsers.push({
            userId: 1,
            firstName: 'Create New Customer'
          })
        }
      })
    } else {
      this.cloneUsers = [];
      this.userChecke = false;
    }
  }

  getCusData(data) {
    this.userData = data;
    if (data.userId == 1) {
      this.customerPop = false;
      this.newCustPop = true;
    }
    this.userCheck = true;
  }

  searchCust() {
    sessionStorage.setItem('userId', this.userData.userId)
    if (this.url.includes('vendor-manage-order'))
      this.router.navigate(['/homeCategories']);
    else
      this.router.navigate(['/newCategories']);
  }


  ionViewWillLeave() {
    this.customerPop = false;
    this.custName = "";
    this.fName = "";
    this.numb = "";
    localStorage.removeItem('showBar')
  }
  orderEdit(data) {
    sessionStorage.setItem('orderId', data.id);
    sessionStorage.setItem('catId', data.categoryId);
    sessionStorage.setItem('vendor', data.vendorId);
    if (this.url.includes('vendor-manage-order')) {
      this.router.navigate(['home-order-edit/', +data.categoryId])
    } else {
      this.router.navigate(['initial-order-edit/', +data.categoryId])
    }

  }

  searchCust1() {
    this.handler.error("Customer is not registered.Please register");
    var num1 = /^[0-9]+$/
    if (this.custName.match(num1)) {
      if (this.custmob.length == 10) {
        sessionStorage.setItem('mobile#', this.custmob);
        this.router.navigate(['/newCategories'])
      } else {
        this.handler.staticError("Please ENTER valid Mobile Number")
      }
    } else {
      sessionStorage.setItem('firstName', this.custName);
      this.router.navigate(['/newCategories'])
    }
  }
  async getConfig() {
    this.data = await this.service.getConfig().toPromise();
    if (this.data) {
      let x = this.data.find(res => res.name == "Billing Config");
      this.config = x.configs.find(dat => dat.shortCdConst == "ACP");
      this.criditValue = this.config.userValue;

    }
  }
  removeChip(i) {
    console.log(this.statussearch.length)
    if (this.statussearch.length == 1) {
      this.statusName = 'select'
    }

    this.statussearch.splice(i, 1);
  }

  acceptOrder(data) {
    if (data.status == 12) {
      this.loader = true;
      let post = {
        "apptDate": data.apptDate,
        "serviceContractorId": data.serviceContractorId,
        "targetSource": data.serviceContractorId,
        "apptEndTime": data.apptEndTime,
        "apptTime": data.apptTime,
      }
      this.service.confirmEmpOrder(data.id, post).subscribe(res => {
        this.loader = false;
        this.handler.res('Order Confirmed Successfully !!');
        // this.getAllOrder(this.date)
        this.searchfilter();
      })
    } else {
      this.handler.res('Already order has been confirmed!!!')
    }
  }

  newOrderEdit(data) {
    sessionStorage.setItem('orderId', data.id);
    if (this.url.includes('vendor-manage-order')) {
      this.router.navigate(['home-new-order/', +data.categoryId])
    } else {
      this.router.navigate(['vendor-new-order/', +data.categoryId])
    }

  }
  openOrderRequests(data) {
    if (this.url.includes('admin-manage-order'))
      this.router.navigate(['/manage-requests/', data.id])
    else
      this.router.navigate(['/order-requests/', data.id])
  }
  advanced() {
    this.advanceSearch = true;
  }
  register() {
    this.popLoad = true;

    if (this.fName && this.numb != "") {
      if (this.fName && this.numb)
        if (this.numb.length == 10) {
          if (this.fName) {
            this.fName = this.fName.toUpperCase();
          }
          var post = {
            contactNbrMob: '+91' + this.numb,
            firstName: this.fName,
            userType: 1,
            orgCode: 'YB',
            genderCd: 1,
            appId: 14,
            roles: ['CUST'],
          }
          Object.assign(post, { paless: true })
          this.loader = true;
          this.service.register(post).subscribe(
            (res: any) => {
              if (res) {
                this.newCustPop = false;
                sessionStorage.setItem('userId', res.userId)
                if (this.url.includes('vendor-manage-order'))
                  this.router.navigate(['/homeCategories']);
                else
                  this.router.navigate(['/newCategories']);
                this.handler.res('Registered Successfully !!')
                this.popLoad = false;
              }
            },
            err => {
              this.handler.err(err);
              this.loader = false;
            })
        } else {
          this.handler.staticError("Please Enter Valid Mobile number")
          this.popLoad = false;
        }
    }
    else {
      this.handler.res("Please Enter The phone number and name");
      this.popLoad = false;
    }
  }
}
